import { FSA, AppDispatch } from '@typings/redux';
import { RSAA, RSAACreator } from 'redux-api-middleware';
import { ROUTE_AUTH_LOGIN } from 'config/routes';
import { getFetchClient } from 'fetch/client';
import { AuthActionType } from 'store/auth/auth.actionType';
import { toApiFormat } from 'utils/api';

// refreshAccessToken removed - not needed with HTTP-only cookies

export const trySessionDestroy: RSAACreator = (baseUrl: string) => {
  return {
    [RSAA]: {
      endpoint: '/logout',
      method: 'DELETE',
      params: toApiFormat({ baseUrl }),
      types: [
        {
          type: AuthActionType.SESSION_DESTROY_REQUEST,
          meta: {
            lockScreen: true,
          },
        },
        AuthActionType.SESSION_DESTROY_SUCCESS,
        {
          type: AuthActionType.SESSION_DESTROY_FAILURE,
          meta: {
            ignoreNotFoundError: true,
            ignoreUnauthorizedError: true,
          },
        },
      ],
    },
  };
};

export const appLogout = (): FSA => {
  return {
    type: AuthActionType.APP_LOGOUT,
    error: {},
    payload: {
      response: {},
    },
  };
};

export const checkAuthSuccess = () => ({
  type: AuthActionType.CHECK_AUTH_SUCCESS,
});

export const checkAuthFailure = () => ({
  type: AuthActionType.CHECK_AUTH_FAILURE,
});

export const logoutAction = () => ({
  type: AuthActionType.APP_LOGOUT,
});

export const checkAuth: RSAACreator = () => {
  return {
    [RSAA]: {
      endpoint: '/me',
      method: 'GET',
      credentials: 'include',
      types: [
        {
          type: AuthActionType.CHECK_AUTH_SUCCESS,
          meta: {
            takeLatest: true,
          },
        },
        AuthActionType.CHECK_AUTH_SUCCESS,
        {
          type: AuthActionType.CHECK_AUTH_FAILURE,
          meta: {
            ignoreUnauthorizedError: true,
          },
        },
      ],
    },
  };
};

export const logout = () => async (dispatch: AppDispatch) => {
  const client = getFetchClient();
  try {
    await client.query({
      method: 'DELETE',
      endpoint: `/logout?base_url=${window.location.origin.replace('://', '%3A%2F%2F')}`,
    });
  } finally {
    dispatch(logoutAction());
    window.location.href = ROUTE_AUTH_LOGIN;
  }
};
